import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Stack,
  Typography,
} from "@mui/material";
import { useUpdateBalanceVisibilityMutation } from "Api/Mutations/User/useUpdateBalanceVisibilityMutation";
import { useUserInfoQuery } from "Auth/Api/Queries/useUserInfoQuery";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.UserSettings.BalanceVisibility;

export const BalanceVisibilityToggle = () => {
  const { t } = useResource();
  const { data: userInfo, isLoading } = useUserInfoQuery();
  const { mutate: updateBalanceVisibility } =
    useUpdateBalanceVisibilityMutation();

  return (
    <Stack gap={1}>
      <Typography variant="h6">{t(RESOURCES.Title)}</Typography>
      <FormControl>
        <FormControlLabel
          control={
            <Checkbox
              checked={userInfo?.isBalanceVisible ?? false}
              disabled={isLoading}
              onChange={(e) =>
                updateBalanceVisibility({ isVisible: e.target.checked })
              }
            />
          }
          label={t(RESOURCES.Label)}
        />
      </FormControl>
      <Typography
        variant="body2"
        color="text.secondary"
        display="flex"
        alignItems="flex-start"
        gap={1}
      >
        <InfoOutlinedIcon sx={{ height: "1rem", width: "1rem", mt: 0.25 }} />
        {t(RESOURCES.Description)}
      </Typography>
    </Stack>
  );
};
